(() => {
  const root = document.querySelector('[data-ph-root]');
  const mapEl = document.getElementById('JspPhChMap');
  if (!root || !mapEl) return;
  let data;
  try { data = JSON.parse(mapEl.textContent); } catch(e) { return; }

  const pages = Array.isArray(data.pages) ? data.pages : [];
  const handle = root.dataset.pageHandle || '';
  const current = pages.find(p => p.handle === handle) || pages[0] || {};

  const heroImg = root.querySelector('[data-ph-hero]');
  const mobileSource = root.querySelector('[data-ph-source-mobile]');
  const titleEl = root.querySelector('[data-ph-title]');
  const leadEl = root.querySelector('[data-ph-lead]');
  const eyebrowEl = root.querySelector('[data-ph-eyebrow]');
  const crumbTitle = root.querySelector('[data-ph-current-title]');
  const relatedWrap = root.querySelector('[data-ph-related]');

  const esc = v => String(v || '').replace(/[<>&"]/g, c => ({'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;'}[c]));
  const isDarkToken = v => String(v || '').toLowerCase().includes('dark') || String(v || '').includes('ダーク') || String(v || '').includes('暗');
  const isLightToken = v => String(v || '').toLowerCase().includes('light') || String(v || '').includes('ライト') || String(v || '').includes('明');

  function detectTheme(){
    const html = document.documentElement, body = document.body;
    const dom = [html.getAttribute('data-theme'), html.getAttribute('data-color-scheme'), html.getAttribute('color-scheme'), html.className, body && body.getAttribute('data-theme'), body && body.getAttribute('data-color-scheme'), body && body.className].join(' ');
    if (isDarkToken(dom)) return 'dark';
    if (isLightToken(dom)) return 'light';

    const candidates = Array.from(document.querySelectorAll('button,a,[role="button"],[aria-label],[data-theme-toggle],.theme-toggle,.color-scheme-toggle'));
    for (const el of candidates){
      const sig = [el.getAttribute('aria-label'), el.getAttribute('title'), el.getAttribute('data-theme'), el.getAttribute('data-current-theme'), el.textContent].join(' ');
      if (isDarkToken(sig)) return 'light';
      if (isLightToken(sig)) return 'dark';
    }
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  function assetUrl(file){
    if (!file) return '';
    if (/^https?:\/\//i.test(file) || file.startsWith('//')) return file;
    if (file.startsWith('/')) return file;
    if (file.startsWith('PASTE-')) return '';
    return `/cdn/shop/files/${file}`;
  }

  function pick(page, mode){
    if (!page || !page.hero) return {};
    return {
      desktop: mode === 'dark' ? page.hero.desktopDark : page.hero.desktopLight,
      mobile: mode === 'dark' ? page.hero.mobileDark : page.hero.mobileLight,
      desktopAlt: mode === 'dark' ? (page.hero.desktopDarkAlt || page.title || '') : (page.hero.desktopLightAlt || page.title || ''),
      mobileAlt: mode === 'dark' ? (page.hero.mobileDarkAlt || page.title || '') : (page.hero.mobileLightAlt || page.title || '')
    };
  }

  function markTheme(mode){
    root.classList.toggle('is-ph-dark', mode === 'dark');
    root.classList.toggle('is-ph-light', mode === 'light');
    root.setAttribute('data-ph-theme', mode);
  }

  function titleForWrap(str){
    const input = String(str || '').trim();
    if (!input) return '';
    return input
      .replace(/([｜／・、。:：])/g, '$1\u200B')
      .replace(/(フィリピン)(?=国際|進出|市場|商談|現地|提携|投資|移住|VIP|政策)/g, '$1\u200B');
  }

  function viewportKey(){
    const w = window.innerWidth || 1440;
    if (w < 750) return 'mobile';
    if (w < 990) return 'tablet';
    return 'desktop';
  }

  function setHeroTitle(fullTitle){
    if (!titleEl) return;
    titleEl.setAttribute('data-full-title', fullTitle);

    const lines = current.titleLines && current.titleLines[viewportKey()];
    if (Array.isArray(lines) && lines.length){
      titleEl.innerHTML = lines
        .map(line => `<span class="jsp-ph__title-line">${esc(line)}</span>`)
        .join('');
      titleEl.classList.add('has-ph-title-lines');
      return;
    }

    titleEl.classList.remove('has-ph-title-lines');
    titleEl.textContent = window.innerWidth < 990 ? titleForWrap(fullTitle) : fullTitle;
  }

  function setCopy(){
    const fullTitle = current.title || document.title || '';
    const eyebrow = current.eyebrow || data.fallback?.eyebrow || 'JAPANSOLVED™ PHILIPPINES CHAMBER';
    if (eyebrowEl) eyebrowEl.textContent = eyebrow;
    setHeroTitle(fullTitle);
    if (leadEl) leadEl.textContent = current.lead || current.short || data.fallback?.lead || leadEl.textContent;
    if (crumbTitle) crumbTitle.textContent = fullTitle;
  }

  function renderRelated(){
    if (!relatedWrap) return;
    const mode = detectTheme();
    const relatedPages = pages.filter(p => p.handle !== handle && !p.excludeFromRelated);
    relatedWrap.setAttribute('data-count', String(relatedPages.length));
    relatedWrap.innerHTML = relatedPages.map(p => {
      const set = pick(p, mode);
      const image = assetUrl(set.desktop || set.mobile);
      const img = image ? `<img src="${esc(image)}" alt="${esc(p.title)}" loading="lazy">` : `<span class="jsp-ph__missing-img" aria-hidden="true"></span>`;
      return `<a class="jsp-ph__card" data-ph-card-handle="${esc(p.handle)}" href="${esc(p.url)}"><div class="jsp-ph__thumb">${img}</div><div class="jsp-ph__card-body"><p class="jsp-ph__card-kicker">${esc(p.num)} ${esc(p.kicker)}</p><h3 class="jsp-ph__card-title">${esc(p.title)}</h3><p class="jsp-ph__card-short">${esc(p.short)}</p></div></a>`;
    }).join('');
  }

  function repaintImages(){
    const mode = detectTheme();
    markTheme(mode);
    if (current){
      const set = pick(current, mode);
      const desktop = assetUrl(set.desktop), mobile = assetUrl(set.mobile);
      if (heroImg && desktop) heroImg.src = desktop;
      if (mobileSource && mobile) mobileSource.srcset = mobile;
      if (heroImg){
        const useMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
        heroImg.alt = useMobile ? (set.mobileAlt || current.title || '') : (set.desktopAlt || current.title || '');
      }
    }
    root.querySelectorAll('.jsp-ph__card[data-ph-card-handle]').forEach(card => {
      const p = pages.find(x => x.handle === card.getAttribute('data-ph-card-handle'));
      const img = card.querySelector('img');
      if (!p || !img) return;
      const set = pick(p, mode);
      const next = assetUrl(set.desktop || set.mobile);
      if (next && img.src !== next) img.src = next;
    });
  }

  function revealSetup(){
    const items = root.querySelectorAll('.reveal-ph');
    if (!('IntersectionObserver' in window)){
      items.forEach(el => el.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting){ entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold:.12 });
    items.forEach(el => io.observe(el));
  }

  function run(){
    setCopy();
    renderRelated();
    repaintImages();
    setTimeout(() => { setCopy(); repaintImages(); }, 80);
    setTimeout(() => { setCopy(); repaintImages(); }, 260);
    setTimeout(() => { setCopy(); repaintImages(); }, 700);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  revealSetup();
  window.addEventListener('load', run);
  window.addEventListener('pageshow', run);
  window.addEventListener('resize', run, { passive:true });
  document.addEventListener('click', e => {
    const t = e.target && e.target.closest && e.target.closest('button,a,[role="button"],[aria-label],[data-theme-toggle],.theme-toggle,.color-scheme-toggle');
    if (!t) return;
    const sig = [t.getAttribute('aria-label'), t.getAttribute('title'), t.textContent, t.className].join(' ').toLowerCase();
    if (sig.includes('dark') || sig.includes('light') || sig.includes('theme') || sig.includes('ダーク') || sig.includes('ライト')){
      setTimeout(run, 60); setTimeout(run, 220); setTimeout(run, 520);
    }
  }, true);
  const mo = new MutationObserver(run);
  mo.observe(document.documentElement, { attributes:true, attributeFilter:['class','data-theme','data-color-scheme','color-scheme'] });
  if (document.body) mo.observe(document.body, { attributes:true, attributeFilter:['class','data-theme','data-color-scheme','color-scheme'] });
})();

/* PH Chamber Inner v1.3.7 image readiness + legacy parent crumb fallback */
(() => {
  const root = document.querySelector('[data-ph-root]');
  const mapEl = document.getElementById('JspPhChMap');
  if(!root || !mapEl) return;
  let data;
  try{ data = JSON.parse(mapEl.textContent); }catch(e){ return; }
  const parent = data.parent || {};
  const parentCrumb = root.querySelector('[data-ph-parent-crumb]');
  if(parentCrumb){
    if(parent.url) parentCrumb.href = parent.url;
    if(parent.jaTitle) parentCrumb.textContent = parent.jaTitle;
  }
  const markReady = () => {
    const hero = root.querySelector('.jsp-ph__hero');
    const img = root.querySelector('[data-ph-hero]');
    if(hero && img && img.getAttribute('src')) hero.classList.add('is-ph-img-ready');
    root.querySelectorAll('.jsp-ph__thumb').forEach(thumb => {
      if(thumb.querySelector('img[src]')) thumb.classList.add('is-ph-img-ready');
    });
  };
  window.addEventListener('load', () => setTimeout(markReady,120));
  window.addEventListener('pageshow', () => setTimeout(markReady,120));
  setTimeout(markReady,200);
  setTimeout(markReady,700);
})();
